import { useState } from 'react';
import { C, POLICE_TITRE, DEGRADE_ACTION } from '../../theme';
import { Micro } from '../../icones';
import { BoutonPrincipal, Titre, Pastille } from '../composants/base';
import { CONNEXIONS, CATEGORIES } from '../donnees';

// Bienvenue en trois temps, montree UNE FOIS apres la premiere connexion.
//
// Les deux derniers ecrans presentaient des interrupteurs dans le prototype. Rien cote
// serveur ne porte encore ces reglages : ils sont donc presentes ici en LECTURE, comme
// une annonce de ce qui vient. Un interrupteur qui ne commande rien est un mensonge, et
// la promesse « rien sans ton accord » perdrait tout son sens des le premier ecran.

export function Onboarding({ termine }: { termine: () => void }) {
  const [etape, setEtape] = useState<0 | 1 | 2>(0);
  const suivant = () => (etape < 2 ? setEtape((e) => (e + 1) as 0 | 1 | 2) : termine());

  return (
    <div style={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {etape === 0 ? <Presentation suivant={suivant} /> : null}
      {etape === 1 ? <Connexions suivant={suivant} /> : null}
      {etape === 2 ? <Domaines suivant={suivant} /> : null}

      <div style={{ display: 'flex', justifyContent: 'center', gap: 7, padding: '0 0 18px 0' }}>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: etape === i ? C.violet : C.inactif,
            }}
          />
        ))}
      </div>
    </div>
  );
}

function Presentation({ suivant }: { suivant: () => void }) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        padding: '0 36px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 96,
          height: 96,
          borderRadius: '50%',
          background: DEGRADE_ACTION,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 10px 24px rgba(108,92,231,0.35)',
        }}
      >
        <Micro taille={44} couleur="#FFFFFF" />
      </div>
      <div style={{ fontFamily: POLICE_TITRE, fontWeight: 600, fontSize: 36, color: C.encre }}>
        Colette
      </div>
      <div style={{ fontSize: 16, color: C.secondaire, lineHeight: 1.5 }}>
        Ton assistant pour toute ta vie quotidienne. Tu vis ta vie, Colette fait le tri.
      </div>
      <div style={{ marginTop: 12, width: '100%' }}>
        <BoutonPrincipal onClick={suivant} hauteur={52}>
          Commencer
        </BoutonPrincipal>
      </div>
    </div>
  );
}

function Connexions({ suivant }: { suivant: () => void }) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        padding: '34px 20px 0 20px',
        overflow: 'hidden',
      }}
    >
      <Titre taille={24}>Connexions</Titre>
      <div style={{ fontSize: 13, color: C.secondaire, lineHeight: 1.5 }}>
        Colette ne lira jamais que ce que tu autorises. Rien n'est branché aujourd'hui : tu
        décideras, source par source, le moment venu.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, flex: 1, overflowY: 'auto' }}>
        {CONNEXIONS.map((connexion) => (
          <div
            key={connexion.cle}
            style={{
              background: C.carte,
              border: `1px solid ${C.bordure}`,
              borderRadius: 14,
              padding: '13px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <div style={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: C.encre }}>{connexion.label}</div>
              <div style={{ fontSize: 12, color: C.secondaire, lineHeight: 1.4 }}>
                {connexion.description}
              </div>
            </div>
            <Pastille fond={C.page} couleur={C.tertiaire}>
              Bientôt
            </Pastille>
          </div>
        ))}
      </div>
      <div style={{ padding: '0 0 22px 0' }}>
        <BoutonPrincipal onClick={suivant}>Continuer</BoutonPrincipal>
      </div>
    </div>
  );
}

function Domaines({ suivant }: { suivant: () => void }) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        padding: '34px 20px 0 20px',
        overflow: 'hidden',
      }}
    >
      <Titre taille={24}>Ce que Colette gère pour toi</Titre>
      <div style={{ fontSize: 13, color: C.secondaire, lineHeight: 1.5 }}>
        Écris-lui ou dicte-lui n'importe quoi de ta journée : elle en tire des événements,
        des tâches, des rappels et des listes, et te les propose avant d'agir.
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 9,
          alignContent: 'flex-start',
          flex: 1,
          overflowY: 'auto',
        }}
      >
        {CATEGORIES.map((label) => (
          <div
            key={label}
            style={{
              borderRadius: 999,
              padding: '8px 14px',
              fontSize: 14,
              fontWeight: 700,
              background: C.violetFond,
              color: C.violetTexte,
              border: `1px solid ${C.violetFond}`,
            }}
          >
            {label}
          </div>
        ))}
      </div>
      <div style={{ padding: '0 0 22px 0' }}>
        <BoutonPrincipal onClick={suivant}>C'est parti</BoutonPrincipal>
      </div>
    </div>
  );
}
